import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconController16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconController16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 3h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1m0 2a1.5 1.5 0 0 0 1.415-1H13.5a.5.5 0 0 0 0-1H7.915A1.5 1.5 0 0 0 6.5 2h-3a1.5 1.5 0 1 0 0 3zm3 8a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zm-1.467-1h.052A1.5 1.5 0 0 1 9.5 11h3a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1-1.415-1H2.5v-1zm-5.533.5v.5a.5.5 0 0 1 0-1zm7-5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1m-4.415 0a1.5 1.5 0 0 1 1.415-1h3a1.5 1.5 0 0 1 1.415 1H13.5a.5.5 0 0 1 0 1h-2.585a1.5 1.5 0 0 1-1.415 1h-3a1.5 1.5 0 0 1-1.415-1H2.5a.5.5 0 0 1 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconController16);
